import React, { Fragment } from 'react';
import Checkbox from '../../../../../common/Checkbox';

const generateMatchesColumns = (
  {
    allSelected,
    isSelected,
    matchesInitialized,
    noMatches,
    onChange,
    onSelectAll,
    selectable,
}) => [
  {
    Header: (
      <div
        className="vendor-matches-table__sort__item"
        role="button"
      >
        <Checkbox
          className="u-margin-0"
          disabled={noMatches || !matchesInitialized}
          display-if={selectable}
          checked={allSelected}
          onChange={onSelectAll}
        />
        <div className="matches-table__with-sorting">Matching SKU number</div>
      </div>
    ),
    accessor: 'sku',
    Cell: row => (
      <Fragment>
        <Checkbox
          className="u-margin-0"
          display-if={selectable}
          checked={isSelected(row.original)}
          onChange={() => onChange(row.original)}
        />
        {row.value}
      </Fragment>
    ),
    width: 270,
  },
  {
    Header: (
      <div
        className="vendor-matches-table__sort__item"
        role="button"
      >
        <div className="matches-table__with-sorting">Name in Squire</div>
      </div>
    ),
    accessor: 'squireName',
    width: 230,
  },
  {
    Header: (
      <div
        className="vendor-matches-table__sort__item"
        role="button"
      >
        <div className="matches-table__with-sorting">Name in Shopify</div>
      </div>
    ),
    accessor: 'shopifyName',
    width: 230,
  },
];

export default generateMatchesColumns;
